import React, {Component} from 'react';
import { LanguageContext } from '../App';

export default class PuzzleImg extends Component {
    render() {
        return (            
            <LanguageContext.Consumer>
                {({ language }) =>
                    <img key={this.props.matchedPuzzle.path[language['jezyk']] + '' + this.props.direction}
                    src={'/akademia/image/puzzles/' +  this.props.matchedPuzzle.path[language['jezyk']]}
                    className={'menu-puzzle menu-puzzle-' + this.props.direction}
                    alt={this.props.matchedPuzzle.path[language['jezyk']] + '' + this.props.direction}
                    onClick={(e) => {
                        let activePuzzle = Object.assign({}, this.props.matchedPuzzle, {'direction': this.props.direction});
                        this.props.setActivePuzzle(activePuzzle);
                        if (this.props.alert) {
                            this.props.hideAlert();
                        }
                        let activeCell = document.getElementsByClassName('active-puzzle')[0];
                        if (activeCell) {
                            activeCell.classList.remove('active-puzzle')
                            activeCell.classList.remove('active-puzzle')
                        }
                        e.currentTarget.classList.add('active-puzzle');
                    }}
        />
                }
            </LanguageContext.Consumer>);
    }
}



// WEBPACK FOOTER //
// ./src/LeftMenu/PuzzleImg.js